var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(flight,index){return _c('div',{key:index},[_c('PdkFlightAvail',{attrs:{"availableFlight":flight},on:{"selected":function($event){return _vm.$emit('selected', $event)}}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }